module.exports = __webpack_public_path__ + "img/AFMS-MapLocation.1f017e1d.png";